import { fetchData } from '../../../../utils/fetch'

interface ILocation {
  name: string
  objectId: string
  active?: boolean
}

export const getLocationList = async (): Promise<ILocation[]> => {
  return fetchData<ILocation[]>({
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/locations/location`,
  })
}
